import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/budgets/")({
  beforeLoad: () => {
    throw redirect({ to: "/budgets/$tab", params: { tab: "projects" }, search: (s: Record<string, unknown>) => s });
  },
});
